import React from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/api";

export default function ResetPassword() {
    const [sp] = useSearchParams();
    const navigate = useNavigate();
    const token = sp.get("token");
    const [email, setEmail] = React.useState("");
    const [password, setPassword] = React.useState("");
    const [confirm, setConfirm] = React.useState("");
    const [loading, setLoading] = React.useState(false);
    const [sent, setSent] = React.useState(false);

    // Stage 1: request reset email
    const requestReset = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/auth/forgot-password", { email, origin: window.location.origin });
            setSent(true);
            toast.success("Dacă emailul există, vei primi un link de resetare");
        } catch (err) {
            toast.error(err.response?.data?.detail || "Eroare");
        }
        setLoading(false);
    };

    // Stage 2: consume token and set new password
    const doReset = async (e) => {
        e.preventDefault();
        if (password !== confirm) return toast.error("Parolele nu coincid");
        if (password.length < 8) return toast.error("Parola trebuie să aibă minim 8 caractere");
        setLoading(true);
        try {
            await api.post("/auth/reset-password", { token, password });
            toast.success("Parolă resetată cu succes! Te poți autentifica acum.");
            setTimeout(() => navigate("/login"), 800);
        } catch (err) {
            toast.error(err.response?.data?.detail || "Token invalid sau expirat");
        }
        setLoading(false);
    };

    return (
        <div className="container-x py-20 max-w-md mx-auto" data-testid="reset-page">
            <h1 className="font-heading text-4xl mb-2">
                {token ? "Setează parolă nouă" : "Ai uitat parola?"}
            </h1>
            <p className="text-sm text-muted-foreground mb-6">
                {token
                    ? "Introdu noua ta parolă mai jos."
                    : "Introdu emailul contului și îți vom trimite un link pentru resetare."}
            </p>

            {!token && !sent && (
                <form onSubmit={requestReset} className="space-y-3">
                    <input required type="email" placeholder="Emailul contului tău"
                           value={email} onChange={(e) => setEmail(e.target.value)}
                           className="input-soft" data-testid="forgot-email" />
                    <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="forgot-submit">
                        {loading ? "Se trimite..." : "Trimite-mi linkul de resetare"}
                    </button>
                </form>
            )}

            {!token && sent && (
                <div className="card-soft p-4 text-sm" data-testid="forgot-sent">
                    <p>Dacă emailul <b>{email}</b> este asociat unui cont, vei primi un email cu un link pentru resetarea parolei în câteva minute.</p>
                    <p className="mt-2 text-muted-foreground">Verifică și folderul Spam. Linkul expiră în 2 ore.</p>
                </div>
            )}

            {token && (
                <form onSubmit={doReset} className="space-y-3">
                    <input required type="password" placeholder="Parolă nouă (min 8 caractere)"
                           value={password} onChange={(e) => setPassword(e.target.value)}
                           className="input-soft" data-testid="reset-password" />
                    <input required type="password" placeholder="Confirmă parola"
                           value={confirm} onChange={(e) => setConfirm(e.target.value)}
                           className="input-soft" data-testid="reset-confirm" />
                    <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="reset-submit">
                        {loading ? "Se salvează..." : "Setează parolă nouă"}
                    </button>
                </form>
            )}

            <p className="mt-6 text-center text-sm text-muted-foreground">
                <Link to="/login" className="text-primary">Înapoi la autentificare</Link>
            </p>
        </div>
    );
}
